<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-slide-group class="py-0" center-active mandatory show-arrows>
          <!-- Slot ปุ่มกดฝั่งซ้าย (Prev) -->
          <template v-slot:prev="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>

          <!-- Slot ปุ่มกดฝั่งขวา (Next) -->
          <template v-slot:next="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>

          <v-slide-item
            v-for="cate in categoryList"
            :key="cate.id"
            v-slot="{ active, toggle }"
            @change="initialize(cate)"
          >
            <v-card
              rounded="lg"
              class="px-2 mx-1"
              @click="toggle"
              elevation="0"
              width="15%"
              :style="
                active
                  ? { border: '1.5px solid', 'border-color': site.color }
                  : ''
              "
            >
              <v-container class="pa-0">
                <v-col class="d-flex justify-center pt-2 pb-0">
                  <v-icon :color="site.color">{{ `mdi-${cate.icon}` }}</v-icon>
                </v-col>
                <p style="font-size: 12px" class="text-center mb-0">
                  {{ cate.label }}
                </p>
              </v-container>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex justify-end py-0" cols="12">
        <p
          @click="$router.push({ name: 'history-coupon' })"
          class="d-flex align-center ma-1 text-end text-subtitle-2 pl-2"
          style="border-radius: 4px; background-color: #ffffff"
        >
          {{ $t("historyCoupon") }} <v-icon>mdi-chevron-right</v-icon>
        </p>
      </v-col>
    </v-row>

    <v-container class="pt-0 mt-2">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in list"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              @click="confirmCoupon(item)"
              :disabled="
                item.can_use == true ? checkExpiredDate(item.expires_at) : true
              "
            >
              <div
                v-if="checkExpiredDate(item.expires_at)"
                class="d-flex justify-center align-center cover-card-disable"
              >
                <div class="label">{{ $t("couponExpired") }}</div>
              </div>

              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>

              <v-row
                class="bottomleft mt-auto mb-0 text-start text-subtitle-2 px-1"
                style="width: calc(100% - 8px)"
              >
                <div
                  v-if="
                    Array.isArray(item.point_used) && item.point_used.length > 0
                  "
                  class="d-flex align-center"
                  style="width: 100%; gap: 4px"
                  :style="{ color: site.color }"
                >
                  <PointSymbol
                    :type="item.point_used[0].point_type_type"
                    :symbol="item.point_used[0].point_type_symbol"
                    :color="item.point_used[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                  <div class="text-truncate">
                    {{ item.point_used[0].point | commaPoint }}
                    {{ item.point_used[0].point_type_name }}
                  </div>
                </div>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <div v-if="!list.length">
        <v-col class="d-flex justify-center mt-16">
          <v-img
            class="white--text mx-auto mt-10 empty"
            :src="require('@/assets/images/out-of-stock.png')"
            max-width="150px"
          >
          </v-img>
        </v-col>
        <p class="text-center">{{ $t("errDataNotFound") }}</p>
      </div>
    </v-container>

    <div>
      <infinite-loading @infinite="infiniteHandler" :identifier="infiniteId">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center pt-5">
          {{ $t("confirmUseCoupon") }}
        </v-card-text>
        <v-card-text class="text-center">{{ dataDialog.name }}</v-card-text>
        <v-card-text class="text-center black--text font-weight-bold">{{
          $t("noteUseCoupon")
        }}</v-card-text>
        <v-card-text class="text-center red--text font-weight-bold pb-0">{{
          $t("noteAlertUseCoupon")
        }}</v-card-text>
        <v-card-actions class="pa-2">
          <v-container>
            <v-row>
              <v-col cols="6" class="text-center">
                <v-btn
                  :color="site.color"
                  class="rounded-lg"
                  outlined
                  block
                  @click="dialog = false"
                >
                  {{ $t("cancel") }}
                </v-btn>
              </v-col>
              <v-col cols="6" class="text-center">
                <v-btn
                  :color="site.color"
                  class="rounded-lg white--text"
                  depressed
                  block
                  @click="useCoupon()"
                >
                  {{ $t("confirm") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CouponDialog
      :dialog="dialogCoupon"
      :data="dataDialog"
      :color="site.color"
      :displayTypes="dataDialog.display_type"
      @close="closeCouponDialog()"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import CouponDialog from "../MyCoupons/component/DialogCoupon.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    HeaderTextBg,
    CouponDialog,
    PointSymbol,
  },

  data: () => ({
    drawer: false,
    group: null,
    model: null,
    page: 1,
    list: [],
    next_page_url: "",
    infiniteId: 0,
    dialog: false,
    dataDialog: {},
    dialogCoupon: false,
    category: "all",
    item: "",
    tab: null,
    size: 150,
    items: ["code", "barCode", "qrCode"],
    categoryList: [],
    title: "",
  }),
  created() {
    this.getCategory();
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "my-coupons");
    this.title = model?.name;
  },
  methods: {
    // ========== ========== ========== ==========
    infiniteHandler($state) {
      Axios.get("reward/myCoupon", {
        params: {
          category: this.category,
          cursor: this.next_page_url,
          type: "redeemed",
        },
      })
        .then(({ data }) => {
          if (data.data.data.length) {
            let has_more = data.data.has_more;
            this.list = this.list.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    initialize(cate) {
      this.isAppLoading(true);
      this.list = [];
      this.next_page_url = "";
      this.infiniteId += 1;
      this.category = cate ? cate.value : "all";
    },
    getCategory() {
      Axios.get("reward/listRewardCategory").then(({ data }) => {
        if (data.status == "success") {
          let cate = data.data;
          cate.map((item) => {
            this.categoryList.push({
              icon: item.icon,
              label: item.label,
              value: item.category,
            });
          });
          this.categoryList.unshift({
            icon: "order-bool-ascending",
            label: this.$t("categoryAll"),
            value: "all",
          });
        }
      });
    },

    useCoupon() {
      Axios.put("reward/getAndUseCoupon", null, {
        params: {
          voucher_code_id: this.dataDialog.id,
        },
      })
        .then(({ data }) => {
          this.dataDialog.code = data.data.code;
          this.dialogCoupon = true;
          this.initialize();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        });
      this.dialog = false;
    },
    confirmCoupon(item) {
      this.dataDialog = item;
      this.items = item.display_type;
      this.dialog = true;
    },
    closeCouponDialog() {
      this.dataDialog = {};
      this.dialog = false;
      this.dialogCoupon = false;
    },
    checkExpiredDate(expireDate) {
      if (!expireDate) return false;
      return moment().startOf("day").isAfter(moment(expireDate).startOf("day"));
    },
  },
  computed: {
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
    isLink() {
      let check = false;
      if (this.dataDialog.code) {
        const regex =
          /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
        check = regex.test(this.dataDialog.code);
      }
      return check;
    },
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.empty {
  opacity: 1;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
  width: 75%;
  text-align: center;
}

.custom-slide-btn {
  background-color: #ffffff !important;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.custom-slide-btn:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.08);
}

.custom-slide-btn .v-icon {
  color: #333333 !important;
}
</style>

<style>
.vue-barcode-element {
  width: 100% !important;
}
</style>
